const TrackingEventEditorModuleConstants = {
    rootStateName: "trackingEvent"
};

export default Object.freeze(TrackingEventEditorModuleConstants);



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/Constants.js
// module id = poHN
// module chunks = 1